<article class="config-container configurator">
    <ng-content></ng-content>
</article>
